import React from "react";
import "./pager.css";
import { useBrand } from "../../context/brand-context";

function buildPages(total, current) {
  if (total <= 6) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = new Set([1, total, current]);
  if (current > 1) pages.add(current - 1);
  if (current < total) pages.add(current + 1);
  pages.add(2);
  pages.add(total - 1);

  const ordered = [...pages].filter(n => n >= 1 && n <= total).sort((a, b) => a - b);

  const withDots = [];
  for (let i = 0; i < ordered.length; i++) {
    const n = ordered[i];
    const prev = ordered[i - 1];
    if (prev && n - prev > 1) withDots.push("…-" + n);
    withDots.push(n);
  }
  return withDots;
}

export default function Pager({ totalPages, page, onChange }) {
  const { brand } = useBrand();              // 'amen' | 'mg'
  const isAmen = brand === "amen";

  if (!totalPages || totalPages <= 1) return null;

  // Variables CSS dynamiques (Amen=rouge, MG=bleu)
  const themeVars = {
    // Couleur principale (texte/boutons)
    "--brand":       isAmen ? "#7a0f18" : "#2563eb",
    "--brandText":   isAmen ? "#7a0f18" : "#2563eb",
    // Fonds « soft »
    "--brandPillBg": isAmen ? "#FEF0EB" : "#EEF2FF",
    // Ombre du bouton actif
    "--brandShadow": isAmen ? "rgba(122,15,24,.25)" : "rgba(37,99,235,.35)",
  };

  const go = (p) => onChange(Math.max(1, Math.min(totalPages, p)));
  const items = buildPages(totalPages, page);

  return (
    <nav className="pager" style={themeVars}>
      <div className="pager__wrap">
        <button
          className="pager__edge"
          onClick={() => go(page - 1)}
          disabled={page <= 1}
          aria-label="Back"
        >
          ‹ Précédent
        </button>

        <div className="pager__nums">
          {items.map((it) =>
            typeof it === "number" ? (
              <button
                key={`p-${it}`}
                className={`pager__num ${it === page ? "is-active" : ""}`}
                onClick={() => go(it)}
                aria-current={it === page ? "page" : undefined}
              >
                {it}
              </button>
            ) : (
              <span key={it} className="pager__dots">…</span>
            )
          )}
        </div>

        <button
          className="pager__edge"
          onClick={() => go(page + 1)}
          disabled={page >= totalPages}
          aria-label="Next"
        >
          Suivant ›
        </button>
      </div>
    </nav>
  );
}
